export const MOVE_TO_POM_OUTCOME_COPY = {
  NON_ROUTABLE_REQUEST_RELEASE_PUBLISH_FAILED: {
    title: 'Nothing was sent to POM',
    detail: 'The request was returned to Pending. You can try again.',
  },
  NON_ROUTABLE_REQUEST_RELEASE_ROLLBACK_FAILED: {
    title: 'This request is STUCK and needs manual review',
    detail:
      'The move to POM could not be confirmed and the request could not be returned to Pending. ' +
      'Check whether a POM order exists for this reference, do not try again, and escalate to ' +
      'engineering.',
  },
  NON_ROUTABLE_REQUEST_CLAIM_FAILED: {
    title: 'The request was not moved to POM',
    detail: 'Refresh the queue to see its current status before acting again.',
  },
  NON_ROUTABLE_REQUEST_RESOLUTION_NOT_RECORDED: {
    title: 'THE ORDER WAS SENT TO POM',
    detail:
      'The fax relay record and this request were NOT updated, so the Relay tab may still show ' +
      'a pending fax order beside the new POM order. DO NOT click Move to POM again: that would ' +
      'dispense this prescription a second time. Escalate to engineering so both records can be ' +
      'corrected.',
  },
};

export default MOVE_TO_POM_OUTCOME_COPY;
